import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useEffect, useState } from "react";
import ModuleHeader from "../components/ModuleHeader";
import ReactEcharts from "echarts-for-react";
import * as echarts from "echarts";
import { REM_CONFIG } from "@/utils/fontSize";
import { mmsApi } from "@/api/mmsApi";
const ShelfOperationStatus = ({ className = "", }) => {
    const chartRef = useRef(null);
    const timerRef = useRef(null);
    const scrollConfig = {
        speed: 0.6,
        visibleCount: 4,
        loop: true,
        interval: 250,
    };
    const [chartData, setChartData] = useState({
        categories: [],
        inUse: [],
        idle: [],
    });
    // 请求接口
    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await mmsApi.getWhShelfStatus();
                const list = res.data || [];
                setChartData({
                    categories: list.map((item) => item.shelfCode),
                    inUse: list.map((item) => item.usedSlots || 0),
                    idle: list.map((item) => item.availSlots || 0),
                });
            }
            catch (err) {
                console.error("获取货架状态失败：", err);
            }
        };
        fetchData();
    }, []);
    const { categories, inUse, idle } = chartData;
    const option = {
        dataZoom: [
            {
                type: "inside",
                xAxisIndex: 0,
                start: 0,
                end: categories.length
                    ? Math.min((scrollConfig.visibleCount / categories.length) * 100, 100)
                    : 100,
                show: false,
                zoomLock: true,
            },
        ],
        backgroundColor: "transparent",
        legend: {
            data: ["在用", "闲置"],
            right: "center",
            top: 8,
            textStyle: { color: "#fff", fontSize: REM_CONFIG.fontSize.small },
            itemGap: 30,
            itemWidth: 16,
            itemHeight: 8,
            icon: "rect",
        },
        grid: {
            left: "10%",
            right: "10%",
            bottom: "15%",
            top: 40,
            containLabel: true,
        },
        tooltip: {
            trigger: "axis",
            axisPointer: { type: "shadow" },
            backgroundColor: "rgba(7,31,75,0.8)",
            borderColor: "#446b9f",
            textStyle: { color: "#fff" },
        },
        xAxis: [
            {
                type: "category",
                axisLabel: {
                    color: "rgba(255,255,255,0.8)",
                    fontSize: REM_CONFIG.fontSize.small,
                },
                splitLine: { show: false },
                axisTick: { show: false },
                axisLine: { lineStyle: { color: "rgba(255,255,255,0.3)" } },
                data: categories,
            },
        ],
        yAxis: [
            {
                type: "value",
                name: "货位数量",
                nameTextStyle: { color: "#fff", fontSize: REM_CONFIG.fontSize.small },
                axisLabel: { color: "#fff", fontSize: REM_CONFIG.fontSize.small },
                splitLine: {
                    lineStyle: { color: "rgba(255,255,255,0.1)", type: "dashed" },
                },
            },
        ],
        series: [
            {
                name: "在用",
                type: "bar",
                barWidth: 16,
                itemStyle: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        { offset: 0, color: "#1B6EAA" },
                        { offset: 1, color: "#109AFE" },
                    ]),
                    borderRadius: [2, 2, 0, 0],
                },
                data: inUse,
                label: {
                    show: true,
                    position: "top",
                    color: "#fff",
                    fontSize: REM_CONFIG.fontSize.small,
                },
            },
            {
                name: "闲置",
                type: "bar",
                barWidth: 16,
                itemStyle: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        { offset: 0, color: "#1CFFFF" },
                        { offset: 1, color: "#AFFFFF" },
                    ]),
                    borderRadius: [2, 2, 0, 0],
                },
                data: idle,
                label: {
                    show: true,
                    position: "top",
                    color: "#fff",
                    fontSize: REM_CONFIG.fontSize.small,
                },
            },
        ],
    };
    // 自动滚动
    const startAutoScroll = (chart) => {
        if (timerRef.current)
            clearInterval(timerRef.current);
        const total = categories.length;
        if (!total)
            return;
        const visiblePercent = (scrollConfig.visibleCount / total) * 100;
        let currentStart = 0;
        timerRef.current = setInterval(() => {
            currentStart += scrollConfig.speed;
            if (currentStart >= 100 - visiblePercent)
                currentStart = 0;
            chart.setOption({
                dataZoom: [{ start: currentStart, end: currentStart + visiblePercent }],
            });
        }, scrollConfig.interval);
    };
    useEffect(() => {
        const chart = chartRef.current?.getEchartsInstance();
        if (!chart)
            return;
        const timer = setTimeout(() => startAutoScroll(chart), 1000);
        const handleResize = () => {
            if (timerRef.current)
                clearInterval(timerRef.current);
            setTimeout(() => startAutoScroll(chart), 300);
        };
        window.addEventListener("resize", handleResize);
        return () => {
            clearTimeout(timer);
            window.removeEventListener("resize", handleResize);
            if (timerRef.current)
                clearInterval(timerRef.current);
        };
    }, [categories]);
    return (_jsxs("div", { className: `relative bg-gradient-to-br from-blue-900/10 to-slate-900/20 ${className}`, children: [_jsx(ModuleHeader, { title: "\u8D27\u67B6\u8FD0\u884C\u72B6\u6001" }), _jsx("div", { className: "h-full min-h-0", children: _jsx(ReactEcharts, { ref: chartRef, echarts: echarts, option: option, style: { width: "100%", height: "100%" }, opts: { renderer: "canvas" } }) })] }));
};
export default ShelfOperationStatus;
